import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  QueryList,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService,
  User,
} from '@spartacus/core'
import { combineLatest, Observable, of } from 'rxjs'
import { filter, map, tap, switchMap, take } from 'rxjs/operators'
// import { PromotionService } from '../../../shared/services/promotion/promotion.service';
import {
  Item,
  CartItemComponent,
} from '../cart-shared/cart-item/cart-item.component'
import { SavedCartService } from '../saved-cart/saved-cart.service'
import { CheckoutService } from '../checkout/checkout/checkout.service'
import { SearchBoxComponentService } from '../../search-box/search-box-component.service'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { BulkServiceService } from '../../bulk-order/bulk-service.service'
import { LaunchDialogService } from '@spartacus/storefront'
import { Actions, ofType } from '@ngrx/effects'
import { QuoteStatus } from './../../../models/status/status.model'
import {
  ActiveCartFacade,
  Cart,
  MultiCartFacade,
  OrderEntry,
  PromotionLocation,
  PromotionResult,
  SelectiveCartFacade,
} from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
import { SpinnerOverlayService } from '../../../shared/components/spinner-overlay/spinner-overlay.service'
import { CommonService } from '../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-cart-details',
  templateUrl: './cart-details.component.html',
  styleUrls: ['./cart-details.component.scss'],
  host: { class: 'CartDetailsPage' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartDetailsComponent implements OnInit {
  cart$: Observable<Cart>
  entries$: Observable<OrderEntry[]>
  cartLoaded$: Observable<any>
  user$: Observable<User>
  loggedIn = false
  orderPromotions$: Observable<PromotionResult[]>
  promotionLocation: PromotionLocation = PromotionLocation.ActiveCart
  promotions$: Observable<PromotionResult[]>
  selectiveCartEnabled: boolean
  userType = ''

  cartEntryList: QueryList<CartItemComponent>

  isLoading = false
  displayMaxSavedCartErrorMsg: boolean = false
  addMoreProduct = false
  public showTextError: boolean
  public incorrectNo: boolean
  public disabledClass: boolean = false
  public uploadArr = []
  public content: any
  cartId: any
  maxCartLimitFlag: boolean = false
  cartsLength: any
  public responseSuccessData: any
  public responseFailureData: any
  QuoteStatus = QuoteStatus
  constructor(
    protected activeCartService: ActiveCartFacade,
    // protected promotionService: PromotionService,
    protected selectiveCartService: SelectiveCartFacade,
    protected authService: AuthService,
    protected routingService: RoutingService,
    private breadCrumbService: BreadcrumbService,
    private cRef: ChangeDetectorRef,
    private spinnerOverlayService: SpinnerOverlayService,
    private savedCartService: SavedCartService,
    private globalMessageService: GlobalMessageService,
    private translate: TranslationService,
    private searchBoxComponentService: SearchBoxComponentService,
    private userAccountFacade: UserAccountFacade,
    private bulkservice: BulkServiceService,
    private launchDialogService: LaunchDialogService,
    public commonService: CommonService,
    private multiCartService: MultiCartFacade,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.user$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )

    this.user$.subscribe(
      (res) => {
        if (res) {
          this.userType = 'current'
        } else {
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    this.loadShoppingCart()
  }
  loadShoppingCart() {
    if (!this.spinnerOverlayService.getOverlayRef()) {
      this.spinnerOverlayService.show()
    }
    this.cart$ = this.activeCartService.getActive()
    /* this.activeCartService.getActiveCartId().subscribe(cartId => {
      this.cart$ = this.checkoutService.getCartReviewOrder(cartId);
    }); */
    // this.promotions$ = this.promotionService.getOrderPromotionsFromCart();
    this.cart$.subscribe((cart) => {
      this.cartId = cart.code
      this.cartsLength = cart.entries?.length
      this.spinnerOverlayService.hide()
    })
    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length > 0))

    this.cartLoaded$ = combineLatest([
      this.activeCartService.isStable(),
      this.selectiveCartEnabled
        ? this.activeCartService.getActive()
        : of(false),
      this.authService.isUserLoggedIn(),
    ]).pipe(
      tap(([, , loggedIn]) => (this.loggedIn = loggedIn)),
      map(([cartLoaded, sflLoaded, loggedIn]) =>
        loggedIn && this.selectiveCartEnabled
          ? cartLoaded && sflLoaded
          : cartLoaded
      )
    )

    /* this.orderPromotions$ = this.promotionService.getOrderPromotions(
      this.promotionLocation
    ); */

    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('savedCart.shoppingCart')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.activeCartService.getLoading().subscribe(
      (r) => {
        this.isLoading = r
        if (r == true) {
          // this.spinnerOverlayService.show();
          if (!this.spinnerOverlayService.getOverlayRef()) {
            this.spinnerOverlayService.show()
          }
        } else {
          this.spinnerOverlayService.hide()
        }
        this.cRef.detectChanges()
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.savedCartService.maxSavedCartErrorNotification.subscribe(
      (data) => {
        this.displayMaxSavedCartErrorMsg = data
        this.cRef.detectChanges()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.searchBoxComponentService.inSearchFlowOnly.next(false)
  }
  saveForLater(item: Item) {
    if (this.loggedIn) {
      this.activeCartService.removeEntry(item)
      this.selectiveCartService.addEntry(item.product.code, item.quantity)
    } else {
      this.routingService.go({ cxRoute: 'login' })
    }
  }

  setCartEntryList(e) {
    this.cartEntryList = e
  }

  scrollCartEntryIntoView(index) {
    const elementToScrollInto = this.cartEntryList.find(
      (el) => el.cartNumber === index
    )
    elementToScrollInto.elRef.nativeElement.scrollIntoView({
      behavior: 'smooth',
    })
  }
  reloadCart(event) {
    this.loadShoppingCart()
    // this.cart$ = this.activeCartService.getActive();
  }
  partEntered() {
    this.showTextError = false
    this.incorrectNo = false
  }
  stopCount(e) {
    var enteredText = e
    var numberOfLineBreaks = (enteredText.match(/\n/g) || []).length
    var characterCount = enteredText.length + numberOfLineBreaks
    if (numberOfLineBreaks > 149) {
      this.disabledClass = true
      e.preventDefault()
      return false
    } else {
      this.disabledClass = false
    }
  }
  uploadContent() {
    this.uploadArr = []
    if (
      this.content == null ||
      this.content == '' ||
      this.content == !this.content
    ) {
      this.showTextError = true
    } else {
      const contentArr = this.content.split(`\n`)
      let contentArr2 = []
      for (let i = 0; i < contentArr.length; i++) {
        if (contentArr[i].length == 0) {
          continue
        } else {
          // this.incorrectNo = true;
          contentArr2 = contentArr[i].split(`,`)
          const obj = {
            productCode: contentArr2[0].trim(),
            quantity: contentArr2[1] ? contentArr2[1].trim() : 1,
            requestedShipDate: '',
            description: contentArr2[2] || '',
          }
          this.uploadArr.push(obj)
        }
      }

      if (!this.incorrectNo) {
        this.bulkservice
          .getBulkCopyPasteList(this.uploadArr, this.userType)
          .subscribe((res: any) => {
            this.responseSuccessData = res.success
            this.responseFailureData = res.failure
            if (res.failure.length == 0) {
              this.checkCartStatus(this.responseSuccessData)
            } else {
              this.nonBuyableParts(this.responseFailureData)
            }
          })
      }
    }
  }

  checkCartStatus(response) {
    let entriesCount
    if (response.length > 0) entriesCount = this.cartsLength + response.length

    if (entriesCount > 150) {
      this.spinnerOverlayService.hide()
      let removeCount = entriesCount - 150
      let errorMsg
      if (this.cartsLength == 150) errorMsg = 'bulkorder.maxShopLimit'
      else errorMsg = 'bulkorder.maxShopLimit2'
      this.globalMessageService.add(
        {
          key: errorMsg,
          params: {
            removeCountJson: removeCount,
            entryLength: this.cartsLength,
          },
        },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0)
      return
    } else {
      this.spinnerOverlayService.hide()
      this.addProductsToCart()
    }
  }
  nonBuyableParts(parts) {
    const componentdata = {
      nonBuyableProducts: parts,
    }

    const nonBuyablePartsDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.NON_BUYABLE_PARTS,
      undefined,
      undefined,
      componentdata
    )
    if (nonBuyablePartsDialog) {
      nonBuyablePartsDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.NON_BUYABLE_PARTS
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value.reason == 'non-buyable-ok')
            this.checkCartStatus(this.responseSuccessData)
        })
    }
  }
  addProductsToCart() {
    this.spinnerOverlayService.show('')
    let bulkEntryObjSuccessArray = []
    let bulkEntryObjSuccess
    for (var i = 0; i < this.responseSuccessData.length; i++) {
      bulkEntryObjSuccess = {
        quantity: this.responseSuccessData[i].quantity,
        product: {
          code: this.responseSuccessData[i].partNumber,
        },
        customerRequestedDate: this.responseSuccessData[i].requestedShipDate,
      }
      bulkEntryObjSuccessArray.push(bulkEntryObjSuccess)
    }
    const apiParams = {
      orderEntries: bulkEntryObjSuccessArray,
    }
    const urlparams = [
      'users',
      this.userType,
      'carts',
      this.cartId,
      'bulkUploadEntries',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.postData(apiUrl, apiParams).subscribe(
      (success) => {
        if (
          success['nonCatalogProductList'] !== undefined &&
          success['nonCatalogProductList'].length > 0
        ) {
          this.bulkservice.priceNotAvailableinSAPProducts.next(
            success['nonCatalogProductList']
          )
        }

        this.multiCartService.loadCart({
          userId: 'current',
          cartId: this.cartId,
          extraData: {
            active: true,
          },
        })
        this.actions$
          .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
          .pipe(take(1))
          .subscribe(
            (r) => {
              this.spinnerOverlayService.hide()
              this.content = null
              this.addMoreProduct = false
            },
            (e) => {
              this.spinnerOverlayService.hide()
              this.globalMessageService.add(
                { key: 'bulkorder.errorOccuredInCart' },
                GlobalMessageType.MSG_TYPE_ERROR,
                5000
              )
            }
          )
      },
      (error) => {
        this.spinnerOverlayService.hide()
      }
    )
  }
  cancel() {
    this.content = null
    // this.addMoreProduct = false;
  }
}
